import { ClaimTypes } from '../redux/SubmitClaim/Common'

export default function (claimObj, benefitTypes = []) {
  let serviceItems = []

  if (ClaimTypes.isDental(claimObj.type) !== true && ClaimTypes.isDrug(claimObj.type) !== true) {
    const benefitType = benefitTypes.find(t => Array.isArray(t.extendedHealthCareTypes))
    if (benefitType) {
      const ehcType = benefitType.extendedHealthCareTypes.find(t => (t.categoryCode === claimObj.categoryCode))
      if (ehcType) {
        serviceItems = ehcType.serviceItems || []
      }
    }
  }

  return serviceItems
}



// WEBPACK FOOTER //
// ./src/util/ExtractServiceItems.js